import React, {Component} from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {setError} from '../../actions/global';
import Modal from 'react-responsive-modal';

import './styles.css';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = { sidebarOpen: false };
        this._toggleSidebar = this._toggleSidebar.bind(this);
        this._closeSidebar = this._closeSidebar.bind(this);
    }

    _toggleSidebar() {
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    }

    _closeSidebar() {
        if (this.state.sidebarOpen) {
            this.setState({ sidebarOpen: false });
        }
    }

    render() {
        let open = this.props.error ? true : false;
        return (
            <div className="Shell" data-open={this.state.sidebarOpen ? 'true' : 'false'}>
                {this.props.loading && <div className="Loading-Bar" />}

                <Sidebar {...this.props} onNavigate={this._closeSidebar} />
                <div className="App-Backdrop" onClick={this._closeSidebar} />

                <div className="Shell-Main">
                    <Header {...this.props} onToggleSidebar={this._toggleSidebar} />

                    <main className="Content">
                        <div className="Content-Inner">
                            <Modal open={open} onClose={() => this.props.dispatch(setError(null))} little>
                                <div className="Error-Modal-Message">
                                    <i className="fa fa-exclamation-triangle" style={{color: 'var(--danger)', fontSize: '1.3em'}} aria-hidden="true"/>
                                    <span>{this.props.error}</span>
                                </div>
                            </Modal>

                            <div className="row">{this.props.children}</div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

Page.propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool,
};

Page.defaultProps = {
    error: null,
    loading: false,
};

function mapStateToProps(state) {
    return {
        error: state.global.error,
        loading: state.global.loading,
    };
}
export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./src/components/Page/index.js